<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false }
})
</script>

<template>
  <div :class="cn('tw-flex tw-flex-col tw-gap-y-1.5 tw-p-6 tw-border-b', props.class)">
    <slot />
  </div>
</template>
